module.exports = __webpack_public_path__ + "img/primary-button-text-color.cc815dd5.svg";